import {Monitor} from '@megaphonenpm/mputils/src/Monitor.js';
import {UpdateRankingsTask} from './UpdateRankingsTask.js';

/**
 * RankingsRecordMonitor reads the specified prediction ranking (e.g., an individual campaign's
 * leaderboard or an individual prediction-group leaderboard), and dispatches a CHANGE event if the
 * ranking record changes.
 */
export class RankingsRecordMonitor extends Monitor {

  constructor (sourceID, dataStore) {
    super(UpdateRankingsTask, [sourceID, dataStore], RankingsRecordMonitor.UPDATE_INTERVAL_DURATION, 'MRTSClient');
  }

  setRankingsInfo (id) {
    this.taskArgs[0] = id;
  }
}

RankingsRecordMonitor.UPDATE_INTERVAL_DURATION = 10000;
